import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlCandidateFicheProject from './ControlCandidateFicheProject.js';
import { getCandidateFiche } from '../../../Api/ExtranetActions.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js';
import { isEmpty } from '../../../Utilities/JsonFunctions.js';
import { getGender } from '../../../Utilities/SnsExtranetFunctions.js';

declare var globalSns;
declare var $;

class ExtranetCandidatesFiche extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getCandidateFiche(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                candidate: data
            });
        });
    }

    render() {
        if (this.state.candidate == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row equalheights">
                    <div className="col-md-6">
                        <div className="ebadge">
                            <h2>{getTranslation("sns.general.extranet.candidateinfo")}</h2>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="EditingFormTable table compact">
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.name")}</div>
                                            <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.name + " " + this.state.candidate.firstName}</p></div>
                                        </div>
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.extranet.candidateinfo.place")}</div>
                                            <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.place}</p></div>
                                        </div>
                                        {
                                            !isEmpty(this.state.candidate.telephone) ?
                                                <div className="tr">
                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.candidateinfo.telephone")}</div>
                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.telephone}</p></div>
                                                </div> : ""
                                        }
                                        {
                                            !isEmpty(this.state.candidate.mobile) ?
                                                <div className="tr">
                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.candidateinfo.mobile")}</div>
                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.mobile}</p></div>
                                                </div> : ""
                                        }
                                        {
                                            !isEmpty(this.state.candidate.email) ?
                                                <div className="tr">
                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.candidateinfo.email")}</div>
                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.email}</p></div>
                                                </div> : ""
                                        }
                                        <div className="tr">
                                            <div className="FieldLabel td">{getTranslation("sns.general.extranet.gender")}</div>
                                            <div className="EditingFormValueCell td">
                                                <p className="form-control-static">{getGender(this.state.candidate.gender)}</p>
                                            </div>
                                        </div>
                                        {
                                            !isEmpty(this.state.candidate.age) ?
                                                <div className="tr">
                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.age")}</div>
                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.age}</p></div>
                                                </div> : ""
                                        }
                                    </div>
                                    {
                                        !(isEmpty(this.state.candidate.currentSalary) &&
                                            isEmpty(this.state.candidate.preferredSalary) &&
                                            isEmpty(this.state.candidate.availability)) ?
                                                <div>
                                                    <h2>{getTranslation("sns.general.extranet.salaryavailability")}</h2>
                                                    <div className="EditingFormTable table compact">
                                                        {
                                                            !isEmpty(this.state.candidate.currentSalary) ?
                                                                <div className="tr">
                                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.currentsalary")}</div>
                                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.currentSalary}</p></div>
                                                                </div> : ""
                                                        }
                                                        {
                                                            !isEmpty(this.state.candidate.preferredSalary) ?
                                                                <div className="tr">
                                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.preferredsalary")}</div>
                                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.preferredSalary}</p></div>
                                                                </div> : ""
                                                        }
                                                        {
                                                            !isEmpty(this.state.candidate.availability) ?
                                                                <div className="tr">
                                                                    <div className="FieldLabel td">{getTranslation("sns.general.extranet.availability")}</div>
                                                                    <div className="EditingFormValueCell td"><p className="form-control-static">{this.state.candidate.availability}</p></div>
                                                                </div> : ""
                                                        }
                                                    </div>
                                                </div> : ""

                                    }
                                    {
                                        (this.state.candidate.educations.length > 0) ?
                                            <div>
                                                <h2>{getTranslation("sns.general.extranet.educations")}</h2>
                                                <ul>
                                                {
                                                    this.state.candidate.educations.map((education) =>
                                                        <li key={education}>{education}</li>
                                                    )
                                                }
                                                </ul>
                                            </div> : ""
                                    }
                                    {
                                        (this.state.candidate.experiences.length > 0) ?
                                            <div>
                                                <h2>{getTranslation("sns.general.extranet.experiences")}</h2>
                                                <ul>
                                                {
                                                    this.state.candidate.experiences.map((experiences) =>
                                                        <li key={experiences}>{experiences}</li>
                                                    )
                                                }
                                                </ul>
                                            </div> : ""
                                    }
                                </div>
                                <div className="col-md-4 candidatePhoto">
                                    {
                                        !isEmpty(this.state.candidate.fotoUrl) ?
                                            <img src={this.state.candidate.fotoUrl} alt="" /> : ""
                                    }
                                    {
                                        !isEmpty(this.state.candidate.linkedIn) ?
                                            <div>
                                                <a href={this.state.candidate.linkedIn} target="_blank" title="LinkedIn">
                                                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                                                    <span className="sr-only">LinkedIn</span>
                                                </a>
                                            </div>: ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="ebadge">
                            <h2>{getTranslation("sns.general.extranet.candidate.openprojects")}</h2>
                            {
                                (this.state.candidate.projects.length > 0) ?
                                    this.state.candidate.projects.map((project) =>
                                        <ControlCandidateFicheProject key={project.id} candidateId={this.props.id} candidateName={this.props.title} project={project}
                                            onNavigateToProjects={() => this.props.onNavigate("extranetProjectsFiche", project.id, project.title)}
                                            onNavigateToDocuments={() => this.props.onSubNavigate("extranetCandidatesDocuments")}
                                            onNavigateToMessages={() => this.props.onSubNavigate("extranetCandidatesMessages")}
                                        />
                                    )
                                    : <span>{getTranslation("sns.general.extranet.candidate.noopenprojects")}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExtranetCandidatesFiche;



// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetCandidatesFiche.js